import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
    title: {
        marginBottom: 30,
        textAlign: 'center',
    },
    description: {
        padding: '0 60px',
        marginBottom: 30,
        textAlign: 'center',
        color: theme.palette.common.black,
        fontSize: '14px',
        lineHeight: '21px',
        letterSpacing: '0.25px',
        fontStyle: 'normal',
    },
    form: {
        background: theme.palette.grey.backgroundMain,
        // width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
    },
    input: {
        marginBottom: 30,
        width: '100%',
    },
    button: {
        marginBottom: 32,
        width: '100%',
        padding: '16px 0',
    },
    link: {
        display: 'block',
        fontWeight: 500,
        fontSize: '14px',
        lineHeight: '16px',
        textAlign: 'center',
        letterSpacing: '1.25px',
        textTransform: 'uppercase',
        color: theme.palette.grey.grey500,
        textDecoration: 'none',
        '&:hover': {
            color: theme.palette.primary.main,
        },
    },
}));
